/* ------------------------- External Dependencies -------------------------- */
import React from 'react';
import { Box } from 'atomic'
/* ---------------------------- Module Package ------------------------------ */
export default props => <Box {...props} onClick={props.dialogOpen}/>



// WEBPACK FOOTER //
// ./src/interface/containers/dialog/DialogClose/render/index.js